export enum TEAM_VIEWS {
  MY_TEAMS = 'own',
  PEER_TEAMS = 'peer',
}
